import { useEffect } from 'react';

/**
 * Register a global ⌘K / Ctrl-K listener that invokes `onOpen`.
 * Prevents the browser default (often focus address bar in some browsers).
 */
export function usePaletteShortcut(onOpen: () => void): void {
    useEffect(() => {
        function handler(e: KeyboardEvent) {
            if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
                e.preventDefault();
                onOpen();
            }
        }
        window.addEventListener('keydown', handler);
        return () => window.removeEventListener('keydown', handler);
    }, [onOpen]);
}
